import React, { FC } from 'react'
import { styled } from '~/app/components'
import { isEmpty } from 'ramda'
import { LeisureProductDetailInfo } from '~/__generated__/__types__'
import { Typography } from '@yanolja-rnd/ya-com-core'

const ListContainer = styled.ul<{ depth: number; level: number }>`
  margin-left: ${({ depth, level }) => (depth === 0 || (depth === 1 && level === 1) ? 0 : '1rem')};
  ${Typography('body1').regular};
  color: ${({ theme }) => theme.color.gray600};
  word-break: break-all;

  .level-0 {
    ${Typography('body1').bold};
    color: ${({ theme }) => theme.color.gray900};
    ::before {
      margin-right: 0;
      content: '';
    }
  }

  .level-1::before {
    content: '•';
  }

  li {
    margin-bottom: 1rem;
    ::before {
      content: '- ';
    }
  }
`

interface IRenderLeisureInfo {
  infos: LeisureProductDetailInfo[]
  level: number
  depth?: number
  parentIndex?: number
}

/**
 * @desc  구조상 무한대의 depth를 가질 수 있는 info data를 indention, prefix와 함께 재귀적으로 렌더하는 컴포넌트.
 *        depth >= 2 부터는 '-' prefix 으로 고정된다.
 *
 * @param infos 무한대의 depth를 가질 수 있는 info data
 * @param level level 에 맞는 스타일을 적용하기 위한 parameter.
 * @param depth nest될 때마다 indent를 증가시키기 위한 parameter. 최초 함수 호출시에는 default(=0)을 사용하는 것을 권장한다.
 * @param parentIndex unique 한 key 를 만들기 위한 parameter
 * */
const LeisureDetailInfo: FC<IRenderLeisureInfo> = ({
  infos,
  level,
  depth = 0,
  parentIndex = 0,
}) => {
  if (isEmpty(infos)) return null

  return (
    <>
      {infos.map(({ content, subContents }, index) => (
        <ListContainer key={`${depth}-${parentIndex}-${index}`} depth={depth} level={level}>
          {content && <li className={`level-${level}`}>{content}</li>}
          <LeisureDetailInfo
            infos={subContents ?? []}
            depth={depth + 1}
            level={level + 1}
            parentIndex={index}
          />
        </ListContainer>
      ))}
    </>
  )
}

export default LeisureDetailInfo
